export default __webpack_public_path__ + "ba403c1069b2c8df11b096f35aad2ca1.png";